<template>
    <h3>1、以電子化取代現有人工作業模式，由學生自行至系統建立個人外語檢定成績資料，並方便學生直接由系統查詢審核結果。<br />
    2、透過系統直接辨識各類外語測驗分數所對應的獎勵等級及補助金額，降低填錯的機會。
    </h3>
</template>

<script>
    export default {
        name: 'AboutUs'
    }
</script>

<style scoped>

</style>